import React from "react";

const Ganesh = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M34 13.876a5.709 5.709 0 00-1.647-3.958 5.654 5.654 0 00-3.917-1.708 5.65 5.65 0 00-4.12 1.628c-.165.16-.317.33-.458.505a18.062 18.062 0 00-1.32-2.237 5.52 5.52 0 00-3.34-2.285A2.094 2.094 0 0018.023 2a2.094 2.094 0 00-1.194 3.806 5.52 5.52 0 00-3.409 2.3c-.538.793-.973 1.53-1.304 2.207a5.814 5.814 0 00-.432-.475 5.65 5.65 0 00-4.12-1.628 5.654 5.654 0 00-3.918 1.708A5.71 5.71 0 002 13.876a5.705 5.705 0 002.085 4.488 5.072 5.072 0 00-.064.855c.027 2.743 2.234 4.975 4.92 4.975 1.285 0 2.253-.336 2.995-.819-1.254-1.516-2.21-3.681-2.21-5.652v-1.2c0-4.545 3.659-8.247 8.172-8.29h.177l.007.001c4.502.057 8.147 3.754 8.147 8.289v1.2a8.296 8.296 0 01-2.197 5.631c.746.494 1.723.84 3.027.84 2.685 0 4.892-2.232 4.92-4.975a5.058 5.058 0 00-.064-.855A5.705 5.705 0 0034 13.876z"
            fill={fill}
        />
        <path className="u_fill"
            d="M24.387 18.35h-2.675v-1.878h2.705c-.027-3.55-2.898-6.42-6.437-6.421h-.004c-3.54 0-6.414 2.87-6.44 6.42h2.71v1.878h-2.68a6.474 6.474 0 003.438 5.115l.001 4.056a1.953 1.953 0 01-1.948 1.957 1.953 1.953 0 01-1.948-1.957v-1.871l-4.022 1.327.056.734a6.811 6.811 0 002.148 4.465A6.752 6.752 0 0013.914 34c3.605 0 6.584-2.833 6.782-6.449l.177-4.048a6.474 6.474 0 003.514-5.154zm-6.366-3.122L16.699 13.9l1.322-1.328 1.321 1.328-1.321 1.328z"
            fill={fill}
        />
    </svg>
);

export default Ganesh;